import './components/script';